import React from "react";
import { motion } from "framer-motion";

const Plans = () => {
  const services = [
    'Access to all gym equipment',
    'Weight Gaining/Weight Loss Program',
    'Functional Workouts and Cardio Workouts',
    'Nutritional Guidance with General Diet Plan',
    'Examining Personal Diet (Veg/Non-Veg)',
    'Workout Examination',
    'Free Yoga Class on Sunday',
  ];

  const gymPlans = [
    {
      title: '1 MONTH',
      subtitle: 'STARTER',
      price: '₹1,500',
      originalPrice: '₹2,000',
      perks: [true, true, true, true, false, false, false],
      popular: false,
      color: 'from-gray-700 to-gray-800'
    },
    {
      title: '3 MONTHS',
      subtitle: 'POPULAR',
      price: '₹4,000',
      originalPrice: '₹6,000',
      perks: [true, true, true, true, true, false, false],
      popular: true,
      color: 'from-yellow-600 to-yellow-700'
    },
    {
      title: '6 MONTHS',
      subtitle: 'RECOMMENDED',
      price: '₹6,000',
      originalPrice: '₹12,000',
      perks: [true, true, true, true, true, true, false],
      popular: false,
      color: 'from-orange-600 to-orange-700'
    },
    {
      title: '1 YEAR',
      subtitle: 'ULTIMATE',
      price: '₹9,999',
      originalPrice: '₹24,000',
      perks: [true, true, true, true, true, true, true],
      popular: false,
      color: 'from-green-600 to-green-700'
    },
  ];

  const durations = [
    { title: '1 Month', price: '₹5,000', sessions: '8 Sessions' },
    { title: '3 Months', price: '₹13,000', sessions: '24 Sessions' },
    { title: '6 Months', price: '₹22,000', sessions: '48 Sessions' },
    { title: '1 Year', price: '₹42,000', sessions: '96 Sessions' },
  ];

  const personaltrainingservices = [
    '100% result oriented program',
    'Everyday Diet Monitoring',
    'Day to Day Follow up',
    'High Intense Training (HIT)',
    'Special Care on Body Shape',
    'Goal Oriented Program',
    'Customised and well monitored workout plans',
    'Specialized core workouts',
    'Personalized and well planned Diet Plan',
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 via-black to-gray-900 text-white min-h-screen">
      
      {/* Hero Section */}
      <motion.section 
        className="relative py-16 lg:py-24 bg-gradient-to-br from-black via-gray-900 to-gray-800"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#fded22]/5 to-transparent"></div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div className="text-center mb-12 lg:mb-16" variants={itemVariants}>
            <motion.h1 
              className="text-4xl sm:text-5xl lg:text-7xl font-black mb-4 lg:mb-6 tracking-tight"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              MEMBERSHIP <span className="text-[#fded22]">PLANS</span>
            </motion.h1>
            <motion.div 
              className="h-1 w-32 lg:w-48 bg-gradient-to-r from-[#fded22] to-yellow-500 mx-auto mb-6"
              initial={{ width: 0 }}
              animate={{ width: "auto" }}
              transition={{ delay: 0.5, duration: 0.8 }}
            />
            <motion.p 
              className="text-xl lg:text-2xl text-gray-300 max-w-3xl mx-auto"
              variants={itemVariants}
            >
              Choose your path to transformation. Every plan includes access to our world-class facilities.
            </motion.p>
          </motion.div>
        </div>
      </motion.section>

      {/* Gym Plans Section */}
      <motion.section 
        className="py-16 lg:py-20"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8"
            variants={containerVariants}
          >
            {gymPlans.map((plan, index) => (
              <motion.div 
                key={index} 
                className={`relative group bg-gradient-to-br ${plan.color} p-6 lg:p-8 rounded-2xl shadow-2xl border-2 ${
                  plan.popular ? 'border-[#fded22] transform scale-105' : 'border-gray-600 hover:border-[#fded22]'
                } transition-all duration-300 cursor-pointer`}
                variants={cardVariants}
                whileHover={{ 
                  scale: plan.popular ? 1.08 : 1.05,
                  y: -10,
                  boxShadow: "0px 25px 50px rgba(253,237,34,0.3)"
                }}
                transition={{ duration: 0.3 }}
              >
                {plan.popular && (
                  <motion.div 
                    className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#fded22] text-black px-4 py-2 rounded-full text-sm font-black uppercase tracking-wider"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.5, type: "spring", stiffness: 200 }}
                  >
                    MOST POPULAR
                  </motion.div>
                )}
                
                <motion.div className="text-center mb-6">
                  <motion.h3 
                    className="text-2xl lg:text-3xl font-black mb-2 text-white"
                    whileHover={{ color: "#fded22" }}
                    transition={{ duration: 0.2 }}
                  >
                    {plan.title}
                  </motion.h3>
                  <motion.p 
                    className="text-sm font-bold text-gray-300 uppercase tracking-wider"
                    whileHover={{ color: "#fded22" }}
                  >
                    {plan.subtitle}
                  </motion.p>
                </motion.div>

                <motion.div className="text-center mb-8">
                  <motion.div className="flex items-center justify-center gap-2 mb-2">
                    <motion.span 
                      className="text-4xl lg:text-5xl font-black text-white"
                      whileHover={{ 
                        scale: 1.1,
                        color: "#fded22"
                      }}
                      transition={{ duration: 0.2 }}
                    >
                      {plan.price}
                    </motion.span>
                  </motion.div>
                  <motion.p 
                    className="text-gray-400 line-through text-lg"
                    whileHover={{ color: "#9ca3af" }}
                  >
                    {plan.originalPrice}
                  </motion.p>
                  <motion.p 
                    className="text-[#fded22] font-bold text-sm"
                    animate={{ opacity: [0.7, 1, 0.7] }}
                    transition={{ duration: 2, repeat: Infinity }}
                  >
                    SAVE {Math.round(((parseInt(plan.originalPrice.replace(/[₹,]/g, '')) - parseInt(plan.price.replace(/[₹,]/g, ''))) / parseInt(plan.originalPrice.replace(/[₹,]/g, ''))) * 100)}%
                  </motion.p>
                </motion.div>

                <motion.ul 
                  className="space-y-3 mb-8"
                  variants={containerVariants}
                >
                  {services.map((service, i) => (
                    <motion.li 
                      key={i} 
                      className="flex items-center text-sm lg:text-base"
                      variants={itemVariants}
                      whileHover={{ 
                        x: 5,
                        color: plan.perks[i] ? "#fded22" : "#ef4444"
                      }}
                      transition={{ duration: 0.2 }}
                    >
                      <motion.div
                        className="mr-3"
                        whileHover={{ scale: 1.3, rotate: 360 }}
                        transition={{ duration: 0.3 }}
                      >
                        {plan.perks[i] ? (
                          <div className="w-5 h-5 bg-[#fded22] rounded-full flex items-center justify-center">
                            <svg className="w-3 h-3 text-black" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          </div>
                        ) : (
                          <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </div>
                        )}
                      </motion.div>
                      <span className={plan.perks[i] ? 'text-white' : 'text-gray-500'}>{service}</span>
                    </motion.li>
                  ))}
                </motion.ul>

                {/* <motion.button 
                  className={`w-full py-3 lg:py-4 rounded-xl font-black text-lg uppercase tracking-wider transition-all duration-300 ${
                    plan.popular 
                      ? 'bg-[#fded22] text-black hover:bg-yellow-400' 
                      : 'bg-white text-black hover:bg-[#fded22]'
                  }`}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  transition={{ duration: 0.2 }}
                >
                  CHOOSE PLAN
                </motion.button> */}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* Personal Training Section */}
      <motion.section 
        className="py-16 lg:py-24 bg-gradient-to-b from-gray-900 to-black"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div className="text-center mb-12 lg:mb-16" variants={itemVariants}>
            <motion.h2 
              className="text-4xl sm:text-5xl lg:text-6xl font-black mb-4 lg:mb-6"
              whileHover={{ scale: 1.02, color: "#fded22" }}
              transition={{ duration: 0.3 }}
            >
              PERSONAL <span className="text-[#fded22]">TRAINING</span>
            </motion.h2>
            <motion.div 
              className="h-1 w-32 lg:w-48 bg-gradient-to-r from-[#fded22] to-yellow-500 mx-auto mb-6"
              initial={{ width: 0 }}
              whileInView={{ width: "auto" }}
              transition={{ duration: 0.8 }}
            />
            <motion.p 
              className="text-xl lg:text-2xl text-gray-300 max-w-3xl mx-auto"
              variants={itemVariants}
            >
              Elite one-on-one coaching for maximum results and personalized attention
            </motion.p>
          </motion.div>
          
          <motion.div 
            className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 lg:p-12 rounded-3xl border border-gray-700 hover:border-[#fded22] transition-all duration-500 shadow-2xl"
            variants={cardVariants}
            whileHover={{ 
              scale: 1.02,
              boxShadow: "0px 30px 60px rgba(253,237,34,0.2)"
            }}
            transition={{ duration: 0.3 }}
          >
            <motion.h3 
              className="text-3xl lg:text-4xl font-black mb-8 lg:mb-12 text-center"
              variants={itemVariants}
              whileHover={{ color: "#fded22", scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              ELITE TRAINING BENEFITS
            </motion.h3>
            
            <motion.div 
              className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12"
              variants={containerVariants}
            >
              {personaltrainingservices.map((service, i) => (
                <motion.div 
                  key={i} 
                  className="flex items-center group"
                  variants={itemVariants}
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <motion.div
                    className="mr-4 w-6 h-6 bg-[#fded22] rounded-full flex items-center justify-center"
                    whileHover={{ scale: 1.3, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <svg className="w-3 h-3 text-black" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </motion.div>
                  <motion.span 
                    className="text-gray-300 group-hover:text-[#fded22] transition-colors duration-300 text-base lg:text-lg"
                    whileHover={{ color: "#fded22" }}
                  >
                    {service}
                  </motion.span>
                </motion.div>
              ))}
            </motion.div>
            
            {/* Pricing Grid */}
            <motion.div 
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
              variants={containerVariants}
            >
              {durations.map((plan, index) => (
                <motion.div 
                  key={index} 
                  className="bg-gradient-to-br from-gray-900 to-black p-6 rounded-2xl border border-gray-600 hover:border-[#fded22] transition-all duration-300 cursor-pointer group"
                  variants={itemVariants}
                  whileHover={{ 
                    scale: 1.05,
                    y: -5,
                    boxShadow: "0px 20px 40px rgba(253,237,34,0.2)"
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <motion.h4 
                    className="text-xl lg:text-2xl font-black mb-2 text-center group-hover:text-[#fded22] transition-colors duration-300"
                    whileHover={{ scale: 1.05 }}
                  >
                    {plan.title}
                  </motion.h4>
                  <motion.p 
                    className="text-3xl lg:text-4xl font-black text-[#fded22] text-center mb-2"
                    whileHover={{ 
                      scale: 1.1,
                      textShadow: "0px 0px 20px rgba(253,237,34,0.8)"
                    }}
                    transition={{ duration: 0.2 }}
                  >
                    {plan.price}
                  </motion.p>
                  <motion.p 
                    className="text-gray-400 text-center text-sm mb-4"
                    whileHover={{ color: "#d1d5db" }}
                  >
                    {plan.sessions}
                  </motion.p>
                  <motion.p 
                    className="text-gray-500 text-center text-xs"
                    whileHover={{ color: "#9ca3af" }}
                  >
                    (All Inclusive)
                  </motion.p>
                  
                  {/* <motion.button 
                    className="w-full mt-4 py-2 bg-transparent border-2 border-[#fded22] text-[#fded22] rounded-lg font-bold hover:bg-[#fded22] hover:text-black transition-all duration-300"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    SELECT
                  </motion.button> */}
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </motion.section>

      {/* Call to Action Section */}
      <motion.section 
        className="py-16 lg:py-20 bg-gradient-to-r from-[#fded22] to-yellow-500"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        variants={containerVariants}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2 
            className="text-4xl lg:text-6xl font-black text-black mb-6"
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
          >
            READY TO TRANSFORM?
          </motion.h2>
          <motion.p 
            className="text-xl lg:text-2xl text-gray-800 mb-8 max-w-3xl mx-auto"
            variants={itemVariants}
          >
            Join hundreds of members who have already transformed their lives at Klimkaara Fitness Center
          </motion.p>
          {/* <motion.button 
            className="bg-black text-[#fded22] px-12 py-4 lg:px-16 lg:py-6 rounded-full text-xl lg:text-2xl font-black uppercase tracking-wider shadow-2xl"
            variants={itemVariants}
            whileHover={{ 
              scale: 1.05, 
              boxShadow: "0px 15px 40px rgba(0,0,0,0.3)",
              y: -5
            }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            START TODAY
          </motion.button> */}
        </div>
      </motion.section>
    </div>
  );
};

export default Plans;
